export default {"theme":{"dark":true,"themes":{"dark":{"primary":"#9e9d24","accent":"#424242","secondary":"#ff8f00","info":"#26a69a","warning":"#ffc107","error":"#dd2c00","success":"#00e676"}}}}
